exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".touchpoint-info[data-v-59fadbca] {\n  position: absolute;\n  padding-right: 30px;\n  right: 0;\n  min-width: 700px;\n  width: 50%;\n  height: 600px;\n  z-index: 1 !important;\n}\n.is-sticky .touchpoint-info[data-v-59fadbca] {\n  right: 39px;\n  padding-right: 1px;\n}\n", ""]);

